var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 730,
    height: 822,
    viewBox: "0 0 730 822",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1103.37 1209C1028.32 1128.89 1016.99 1112.14 973.184 1034.54C962.449 1015.53 946.444 979.254 932.458 935.245C928.264 922.075 924.606 909.083 921.371 896.326C898.334 805.043 906.833 707.546 928.254 613.067C982.917 372.007 881.448 133.494 690.435 41.5412C499.092 -50.5624 262.009 24.3141 130.569 174.287C113.468 193.801 37.1136 286.49 12.4653 396.395C-65.4554 743.393 255.111 930.897 757.768 1108.97C767.547 1112.42 814.377 1126.94 824.349 1129.75L1103.4 1209.04L1103.37 1209Z",
    stroke: "black",
    strokeOpacity: 0.49,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape2.ac5bf4c0b8f3eb9e1356dff65bfd192f.svg";
export { ForwardRef as ReactComponent };